import React, { useContext } from 'react';
import { styled } from 'linaria/react';
import { RegularButton as Button, RegularButtonSize, Adaptive } from 'fronton-react';
import { RouteContext } from 'entries/common/widgets/context';
import { routes } from 'pages/main/form-router';
import { CalculationFooter } from 'pages/calculation/components/CalculationFooter';

export const SurfaceFooter = (props: { size: RegularButtonSize }) => (
  <Button role="button" size={props.size} variant="primary" label="Далее" type="submit" form="surface-form">
    Далее
  </Button>
);

export const DimensionsFooter = ({ size }: { size: RegularButtonSize }) => (
  <Button
    role="button"
    size={size}
    variant="primary"
    label="Рассчитать количество"
    type="submit"
    form="dimensions-form">
    Рассчитать количество
  </Button>
);

export const Footer = () => {
  const { context: currentRoute } = useContext(RouteContext);
  switch (currentRoute) {
    case routes.surface:
      return (
        <Container>
          <Adaptive to="tablet">
            <SurfaceFooter size="s" />
          </Adaptive>
          <Adaptive from="tablet">
            <SurfaceFooter size="l" />
          </Adaptive>
        </Container>
      );
    case routes.dimensions:
      return (
        <Container>
          <Adaptive to="tablet">
            <DimensionsFooter size="s" />
          </Adaptive>
          <Adaptive from="tablet">
            <DimensionsFooter size="l" />
          </Adaptive>
        </Container>
      );
    case routes.calculation:
      return (
        <Container>
          <CalculationFooter />
        </Container>
      );
    default:
      return (
        <Container>
          <div>default</div>
        </Container>
      );
  }
};

const Container = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: space-between;

  min-height: 112px;
  padding: var(--space-400) 104px;
  background-color: var(--background-primary);
  box-shadow: var(--box-shadow-m);

  @media (--only-desktop) {
    padding: var(--space-400) var(--space-525);
  }

  @media (--only-tablet) {
    padding: var(--space-400) var(--space-675);
  }

  @media (--only-mobile) {
    flex-wrap: wrap;
    min-height: 90px;
    padding: var(--space-100) var(--space-200);
  }
`;
